<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="5" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">推荐岗位</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">推荐岗位</div>
    </div>
    <div class="head01">
      <Header :activeIndex="5" v-if="!isMobile" />
      <div class="head02">
        <div class="head03">
          <el-select v-model="locationFilter" placeholder="请选择工作地点筛选" @change="handleLocationFilterChange" class="head04">
            <el-option label="偏好工作地点" value="preferred"></el-option>
            <el-option label="全部工作地点" value="all"></el-option>
          </el-select>
        </div>
        <div>
          <div>
            <el-table v-if="!isMobile" :data="tableData" stripe class="tabletou" :height="tableHeight">
              <el-table-column label="序号" width="100">
                <template #default="scope">
                  {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="jobName" label="职位名称" width="230">
              </el-table-column>
              <el-table-column prop="degree" label="学历要求" width="150">
              </el-table-column>
              <el-table-column prop="workplace" label="工作地点" width="130">
              </el-table-column>
              <el-table-column prop="minSalary" label="最低薪资" width="130">
              </el-table-column>
              <el-table-column prop="maxSalary" label="最高薪资" width="130">
              </el-table-column>
              <el-table-column prop="jobDuties" label="岗位职责" width="550">
                <template #default="{ row }">
                  <div v-if="row.jobDuties">
                    {{ JSON.parse(row.jobDuties).join('') }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row v-else :gutter="20" class="tabletou" :height="tableHeight">
              <el-col :span="24" v-for="(item, index) in tableData" :key="index"
                style="margin-top:20px;margin-left:0px;margin-right:0px;">
                <el-card class="mobile-card" shadow="hover">
                  <div class="card-content">
                    <div class="card-header">
                      <span class="card-title">职位名称: {{ item.jobName }}</span>
                    </div>
                    <div class="card-body">
                      <div class="card-info">
                        <p><strong>学历要求:</strong> {{ item.degree }}</p>
                        <p><strong>工作地点:</strong> {{ item.workplace }}</p>
                        <p><strong>薪资范围:</strong> {{ item.minSalary }} - {{ item.maxSalary }}</p>
                      </div>
                      <div class="card-duties">
                        <strong>岗位职责:</strong>
                        <p>{{ JSON.parse(item.jobDuties).join(' ') }}</p>
                      </div>
                    </div>
                    <div class="card-footer">
                      <el-button @click="handleClick(item)" type="text" size="small">查看详情</el-button>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-pagination v-if="!isMobile" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"
          style="margin-top: 20px;"></el-pagination>
        <el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"
          style="margin-top: 20px;" :pager-count="5" class="compact-pagination">
        </el-pagination>
        <el-dialog title="公司信息" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="公司名称" :label-width="formLabelWidth">
              <div class="shuju">{{ form.companyName }}</div>
            </el-form-item>
            <el-form-item label="公司规模" :label-width="formLabelWidth">
              <div class="shuju">{{ form.companySize }}</div>
            </el-form-item>
            <el-form-item label="成立时间" :label-width="formLabelWidth">
              <div class="shuju">{{ formatDate(form.foundingDate) }}</div>
            </el-form-item>
            <el-form-item label="电话号码" :label-width="formLabelWidth">
              <div class="shuju">{{ form.phoneNumber }}</div>
            </el-form-item>
            <el-form-item label="邮箱" :label-width="formLabelWidth">
              <div class="shuju">{{ form.email }}</div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: '',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tableStyle: {
        width: '100%',
        height: `${window.innerHeight - 300}px`
      },
      tableData: [],
      disTableData: [],
      // BASE_URL: 'http://192.168.2.8:8204',
      // BASE_URL1: 'http://192.168.2.8:8206',
      BASE_URL: 'https://zhiyedashi.com/job',
      BASE_URL1: 'https://zhiyedashi.com/info',
      userId: sessionStorage.getItem("userId"),
      major: '',
      degree: '',
      pageSize: 20,
      currentPage: 1,
      total: 0,
      tableHeight: "",
      dialogFormVisible: false,
      form: {
        companyName: '',
        companySize: '',
        foundingDate: '',
        industryName: '',
        phoneNumber: '',
        email: ''
      },
      formLabelWidth: '120px',
      preferredLocation: '',
      pipeidata: [],
      pipeidatas: [],
      locationFilter: 'preferred',
      alltotal: 0,
      dataBatches: {},
      loadedBatches: 1,
      currentBatch: 1,
      hasMoreData: true,
      isLoading: false,
      isMergingData: false,
      lastLoadedPage: 0,
      preloadThreshold: 3,
      preloadScheduled: false,
      loading: true,
      address: '',
      isMobile: false,
      xueyexinxi: sessionStorage.getItem("xueyexinxi") === "true",
      zhiyeceshi: sessionStorage.getItem("zhiyeceshi") === "true",
    }
  },
  mounted() {
    if (this.zhiyeceshi && this.xueyexinxi) {
      this.selectMajorDegree()
    } else {
      // 判断学生信息和职业测试哪个是false
      if (!this.xueyexinxi) {
        alert("请先填写学业信息")
        this.$router.push('/personalInf');
      } else {
        alert("请先填写测试问题")
        this.$router.push('/CareerQuiz');
      }
    }
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.userId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
    this.getTableHeight();
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleLocationFilterChange(value) {
      this.locationFilter = value;
      // console.log("this.locationFilter", this.locationFilter);
      this.currentPage = 1
      if (value === 'preferred') {
        this.selectQiyeHobby()
      } else {
        this.selectQiyeJobPage()
      }
    },
    formatDate(isoString) {
      const date = new Date(isoString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    getTableHeight() {
      let tableH = 210;
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    handleClick(row) {
      // console.log(row.qiyeId);
      const qiyeId = row.qiyeId
      fetch(`${this.BASE_URL1}/admin/company/selectByUserId`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${qiyeId}`
      })
        .then(res => res.json())
        .then(data => {
          this.dialogFormVisible = true
          this.form = data.data
        })
        .catch(error => {
          console.error("查询公司信息失败，原因是", error)
        })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.updatePagedData()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.locationFilter === 'preferred') {
        this.selectQiyeHobby()
      } else {
        this.selectQiyeJobPage()
      }
    },
    updatePagedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.locationFilter === 'preferred') {
        // 优选地点的逻辑
        this.pipeidatas = this.pipeidata.slice(start, end)
      } else {
        // console.log("执行");
        this.disTableData = this.tableData.slice(start, end);
        // console.log(this.disTableData);
      }
    },
    selectMajorDegree() {
      fetch(`${this.BASE_URL1}/admin/resumes/selectResumes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.data === '暂无学业信息') {
            this.isDisabled = false
          } else {
            let resumes = data.data
            this.preferredLocation = resumes.preferredLocation
            this.degree = resumes.degree
            this.major = resumes.major

            if (sessionStorage.getItem("address")) {
              this.selectQiyeHobby()
            } else {
              if (resumes.preferredLocation) {
                this.selectAddress()
              } else {
                this.selectQiyeHobby()
              }
            }
          }
        })
        .catch(error => {
          console.error("查询专业和学历失败，原因是", error);
        });
    },
    selectAddress() {
      fetch(`${this.BASE_URL1}/admin/rc/selectAddress`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `preferredLocation=${this.preferredLocation}`
      })
        .then(res => res.json())
        .then(data => {
          this.address = data.join(',');
          sessionStorage.setItem("address", this.address)
          this.selectQiyeHobby()
        })
        .catch(error => {
          console.error("查询地址失败，原因是", error);
        })
    },
    selectQiyeHobby() {
      console.log("1");
      this.address = sessionStorage.getItem("address")
      fetch(`${this.BASE_URL}/admin/qiyejob/selectQiyeHobby`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `page=${this.currentPage}&limit=${this.pageSize}&major=${this.major}&degree=${this.degree}&allLocationsToMatch=${this.address}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log(data);
          this.tableData = data.data.list
          this.total = data.data.total
          // console.log(this.total);
          if (this.total === 0) {
            this.locationFilter = 'all'
            this.selectQiyeJobPage()
          }
        })
        .catch(error => {
          console.error("查询推荐岗位/分页查询偏好地址失败，原因是", error);
        })
    },
    selectQiyeJobPage() {
      console.log("2");
      fetch(`${this.BASE_URL}/admin/qiyejob/selectQiyeJobPage`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `page=${this.currentPage}&limit=${this.pageSize}&major=${this.major}&degree=${this.degree}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log(data);
          this.tableData = data.data.list
          this.total = data.data.total
        })
        .catch(error => {
          console.error("查询推荐岗位/分页查询偏好地址失败，原因是", error);
        })
    }
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-dialog {
  width: 50% !important;
}

@media (max-width: 768px) {
  .el-dialog {
    width: 97% !important;
  }
}
</style>

<style scoped>
.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 70px;
}

.head02 {
  margin-bottom: 20px;
}

.head03 {
  display: flex;
  align-items: left;
  margin-top: 20px;
}

.head04 {
  width: 250px;
}

.tabletou {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.shuju {
  text-align: left;
  font-size: 17px;
  font-weight: 700;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

@media (max-width: 768px) {
  .head01 {
    gap: 10px;
    padding-top: 140px;
  }

  .head02 {
    width: 100%;
    padding: 0px;
  }

  .head03 {
    margin-top: 10px;
    justify-content: center;
  }

  .head04 {
    width: 100%;
    max-width: 250px;
  }

  .tabletou {
    width: 100%;
    overflow-x: auto;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .shuju {
    font-size: 14px;
  }

  .mobile-card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .card-content {
    display: flex;
    flex-direction: column;
  }

  .card-header {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .card-body {
    margin-bottom: 15px;
  }

  .card-info p,
  .card-duties p {
    margin: 5px 0;
  }

  .card-footer {
    text-align: right;
  }

  .card-title {
    display: block;
    font-size: 16px;
    color: #333;
  }

  .logo {
    width: 50px;
  }

  .el-dialog {
    width: 97% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qiyeJob.vue